// frontend/src/components/layout/UserLayout.js
import React, { useState, useRef, useEffect } from 'react';
import { Outlet, NavLink, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import useFetch from '../../hooks/useFetch';
import axios from 'axios';
import { FaEnvelopeOpenText, FaUserShield } from 'react-icons/fa';

// İKONLAR (Aynı)
const Icons = {
  Panel: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 mr-3"><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" /></svg>,
  Duyuru: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 mr-3"><path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688 0-1.25-.562-1.25-1.25s.562-1.25 1.25-1.25 1.25.562 1.25 1.25-.562 1.25-1.25 1.25-.562 1.25-1.25 1.25-.562 1.25-1.25 1.25-.562 1.25-1.25 1.25-.562 1.25-1.25 1.25z" /><path strokeLinecap="round" strokeLinejoin="round" d="M9 10.5h.008v.008H9v-.008zm5.992 0h.008v.008h-.008v-.008z" /><path strokeLinecap="round" strokeLinejoin="round" d="M3.375 6.75h17.25c.621 0 1.125-.504 1.125-1.125V3.375c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v2.25c0 .621.504 1.125 1.125 1.125zM3.375 19.5h17.25c.621 0 1.125-.504 1.125-1.125v-2.25c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v2.25c0 .621.504 1.125 1.125 1.125zM12 17.25a3.75 3.75 0 003.75-3.75V9.375a3.75 3.75 0 10-7.5 0v4.125A3.75 3.75 0 0012 17.25z" /></svg>,
  Oneri: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 mr-3"><path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM18 15.75l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 18l-1.035.259a3.375 3.375 0 00-2.456-2.456L18 21.75l-.259-1.035a3.375 3.375 0 00-2.456-2.456L14.25 18l1.035-.259a3.375 3.375 0 002.456-2.456L18 15.75z" /></svg>,
  Havuz: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 mr-3"><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>,
  Profil: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 mr-3"><path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
  Cikis: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 mr-3"><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" /></svg>,
  Bildirim: () => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 mr-3"><path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" /></svg>
};

const NavItem = ({ to, icon, label, onClick }) => (
    <NavLink 
        to={to} 
        onClick={onClick} 
        className={({ isActive }) => 
            `flex items-center px-4 py-2.5 text-sm font-medium rounded-lg transition-colors duration-200 ${isActive ? 'bg-primary text-white' : 'text-text-secondary hover:bg-gray-800 hover:text-white'}`
        }
    >
        {icon} {label}
    </NavLink>
);

const UserLayout = () => {
    const { logout, userInfo } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [notificationsOpen, setNotificationsOpen] = useState(false);
    const notifRef = useRef(null);
    
    // --- API URL TANIMI (ÖNEMLİ DÜZELTME) ---
    // Eğer Production modundaysa '/api' kullanır, değilse localhost:5000'e gider.
    const API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api';
    // ----------------------------------------

    const location = useLocation(); 
    const initialized = useRef(false);

    // 1. Session Start Log 
    useEffect(() => {
        if (!initialized.current) {
            const logSession = async () => {
                try {
                    const token = localStorage.getItem('token')?.replace(/"/g, '');
                    if (token) {
                        // URL DÜZELTİLDİ: ${API_URL}/extras/log-activity
                        await axios.post(`${API_URL}/extras/log-activity`, 
                            { type: 'session_start', details: 'Sisteme giriş yaptı / Sayfa yeniledi' },
                            { headers: { Authorization: `Bearer ${token}` } }
                        );
                    }
                } catch (err) { console.error("Log error", err); }
            };
            logSession();
            initialized.current = true;
        }
    }, [API_URL]); // dependency eklendi

    // 2. Page View Log 
    useEffect(() => {
        const logPageView = async () => {
            try {
                const token = localStorage.getItem('token')?.replace(/"/g, '');
                if (token) {
                    // URL DÜZELTİLDİ: ${API_URL}/extras/log-activity
                    await axios.post(`${API_URL}/extras/log-activity`, 
                        { type: 'page_view', details: `Gezilen Sayfa: ${location.pathname}` },
                        { headers: { Authorization: `Bearer ${token}` } }
                    );
                }
            } catch (err) { console.error("Log error", err); }
        };
        
        if (location.pathname !== '/login') {
            logPageView();
        }
    }, [location, API_URL]); // dependency eklendi

    const { data: notifications } = useFetch('/extras/notifications');
    const unreadCount = notifications ? notifications.filter(n => !n.isRead).length : 0;

    useEffect(() => {
        function handleClickOutside(event) {
            if (notifRef.current && !notifRef.current.contains(event.target)) {
                setNotificationsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [notifRef]);

    const handleNavClick = () => {
        setSidebarOpen(false);
    };

    return (
        <div className="min-h-screen bg-background">
            {/* HEADER */}
            <div className="fixed top-0 left-0 right-0 h-16 bg-surface border-b border-border z-40 flex items-center justify-between px-4 lg:pl-72 lg:pr-8 transition-all duration-300">
                <div className="flex items-center lg:hidden">
                     <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-text-secondary hover:text-white p-2 mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8"><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" /></svg>
                    </button>
                    <img src="/logo.png" alt="HPS" className="w-16 object-contain" />
                </div>
                <div className="hidden lg:block"></div>

                <div className="flex items-center gap-4 ml-auto">
                    {/* Bildirim Zili */}
                    <div className="relative" ref={notifRef}>
                        <button onClick={() => setNotificationsOpen(!notificationsOpen)} className="relative p-2 text-text-secondary hover:text-white transition-colors rounded-full hover:bg-background focus:outline-none" title="Bildirimler">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                            </svg>
                            {unreadCount > 0 && (
                                <span className="absolute top-1 right-1 h-4 w-4 bg-danger text-white text-[10px] font-bold flex items-center justify-center rounded-full border border-surface animate-pulse">
                                    {unreadCount}
                                </span>
                            )}
                        </button>

                        {notificationsOpen && (
                            <div className="absolute right-0 mt-2 w-80 bg-surface border border-border rounded-lg shadow-2xl overflow-hidden z-50 origin-top-right">
                                <div className="p-3 border-b border-border bg-background/50 flex justify-between items-center">
                                    <h3 className="text-sm font-semibold text-text-primary">Bildirimler</h3>
                                    <Link to="/user/notifications" className="text-xs text-primary hover:underline" onClick={() => setNotificationsOpen(false)}>Tümünü Gör</Link>
                                </div>
                                <div className="max-h-64 overflow-y-auto custom-scrollbar">
                                    {notifications && notifications.length > 0 ? (
                                        notifications.slice(0, 5).map((notif, idx) => (
                                            <div key={idx} className={`p-3 border-b border-border/50 ${!notif.isRead ? 'bg-primary/5' : ''}`}>
                                                <p className="text-sm text-white font-medium">{notif.title}</p>
                                                <p className="text-xs text-text-secondary truncate">{notif.message}</p>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="p-4 text-center text-text-secondary text-sm">Bildirim yok.</div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    
                    {/* Profil Linki */}
                    <Link to="/user/profile" className="hidden lg:flex items-center gap-3 p-1 pr-3 rounded-full hover:bg-surface border border-transparent hover:border-border transition-all group">
                         <div className="text-right">
                             <p className="text-sm font-semibold text-text-primary group-hover:text-primary transition-colors">{userInfo?.name}</p>
                             <p className="text-xs text-text-secondary">Profilim</p>
                         </div>
                        <img 
                            src={
                                userInfo?.avatar && !userInfo.avatar.includes('ui-avatars.com') 
                                ? userInfo.avatar 
                                : '/avatar/default-avatar.png'
                            } 
                            alt={userInfo?.name} 
                            className="h-10 w-10 rounded-full object-cover border-2 border-background shadow-md group-hover:shadow-primary/50 transition-all"
                        />
                    </Link>
                </div>
            </div>

            {/* OVERLAY */}
            {sidebarOpen && (<div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)}></div>)}

            {/* SIDEBAR */}
            <aside className={`fixed inset-y-0 left-0 bg-surface w-64 flex flex-col z-50 border-r border-border transition-transform duration-300 ease-in-out lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:fixed lg:h-screen`}>
                <div className="flex flex-col items-center justify-center h-32 border-b border-border flex-shrink-0 bg-background/30">
                    <img src="/logo.png" alt="PAYDA Logo" className="w-24 object-contain mb-2 filter drop-shadow-lg" />
                    <span className="text-xs font-semibold text-text-secondary tracking-widest uppercase opacity-70">Ortak PAYDA Noktası</span>
                </div>
                
                <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto scrollbar-thin">
                    <NavItem to="/user/dashboard" icon={<Icons.Panel />} label="Panel" onClick={handleNavClick} />
                    <NavItem to="/user/announcements" icon={<Icons.Duyuru />} label="Duyurular" onClick={handleNavClick} />
                    <NavItem to="/user/notifications" icon={<Icons.Bildirim />} label="Bildirimler" onClick={handleNavClick} />
                    <NavItem to="/user/recommendations" icon={<Icons.Oneri />} label="Akıllı Öneriler" onClick={handleNavClick} />
                    <NavItem to="/user/mailpool" icon={<Icons.Havuz />} label="E-Mail Havuzu" onClick={handleNavClick} />
                    <NavItem to="/user/profile" icon={<Icons.Profil />} label="Profilim" onClick={handleNavClick} />
                    
                    {/* Web Mail */}
                    <div className="pt-4 mt-2 border-t border-border space-y-2">
                        <a 
                            href="https://webmail.payda.web.tr" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            onClick={handleNavClick}
                            className="flex items-center px-4 py-2.5 text-sm font-medium rounded-lg text-blue-400 hover:bg-blue-500/10 hover:text-blue-300 transition-colors duration-200"
                        >
                            <FaEnvelopeOpenText className="h-5 w-5 mr-3" />
                            Web Mail
                        </a>

                        {/* Admin Linki */}
                        {userInfo?.role === 'admin' && (
                             <NavLink 
                                to="/admin/dashboard" 
                                onClick={handleNavClick} 
                                className="flex items-center px-4 py-2.5 text-sm font-medium rounded-lg text-yellow-400 hover:bg-yellow-500/10 hover:text-yellow-300 transition-colors duration-200"
                            >
                                <FaUserShield className="h-5 w-5 mr-3" />
                                Admin Paneli
                            </NavLink>
                        )}
                    </div>
                </nav>

                <div className="px-4 py-4 border-t border-border flex-shrink-0 bg-background/30">
                    <button onClick={logout} className="flex items-center justify-center w-full px-4 py-3 text-sm font-bold rounded-lg text-white bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 transition-all duration-200 shadow-lg shadow-red-900/20 transform hover:scale-[1.02]">
                        <Icons.Cikis /> Çıkış Yap
                    </button>
                </div>
            </aside>

            <div className="lg:pl-64 flex flex-col min-h-screen pt-16">
                <main className="flex-grow py-8 px-4 md:px-8"><Outlet /></main>
                <footer className="w-full text-center p-6 mt-auto border-t border-border text-text-secondary text-sm bg-surface/50">
                    <span>© 2025 aps.<a href="https://www.urartech.com" target="_blank" title="URARTECH Web Yazılım">URARTECH</a> | Her Hakkı Saklıdır.</span>
                </footer>
            </div>
        </div>
    );
};
export default UserLayout;